import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemDaisyFlowers extends Item {
    constructor() {
        super(definitions.ITEM_ID.DAISY_FLOWERS, texture("prop_daisy_flowers_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}